module.exports = __webpack_public_path__ + "img/coffin.0299f0d5.svg";